import { Constants, effectsVolume } from "@core/Utils/Constants";
import { autoScaleFont } from "@core/Utils/HelperFunction";
import { Client } from "@core/Client";

export class BetChips extends Phaser.GameObjects.Container {
    public betButtons = new Array<BetButton>();
    private chipOffset: number;
    private chipNum: number;
    private eraser: boolean;

    constructor(scene: Phaser.Scene, spriteSheet: string, chipIcons: string[], textStyle, chipOffset: number = 1, eraser: boolean = false, eraserIcons: string[] = null, fontScale: number = 0.55, selectionAnimations: string[] = null, fontPadding: number = 0.6) {
        super(scene);

        this.eraser = eraser;
        this.chipOffset = chipOffset;

        this.chipNum = chipIcons.length / 2;
        if (this.eraser)
            this.chipNum++;

        this.betButtons = new Array<BetButton>();
        let chipImageIndex: number = 0;
        Client.logic.ChipValues.forEach((value, index) => {
            let betButton;
            if (value == 0) {
                if (eraser) {
                    betButton = new Eraser(scene, this, 0, spriteSheet, eraserIcons[0], eraserIcons[1], eraserIcons[2]);
                    this.betButtons.push(betButton);
                    this.add(betButton);
                }
            }
            else {
                let selectionAnimation = null;
                if (selectionAnimations && selectionAnimations[chipImageIndex])
                    selectionAnimation = selectionAnimations[chipImageIndex];

                betButton = new BetButton(scene, this, index, spriteSheet, chipIcons[(chipImageIndex * 2)], chipIcons[(chipImageIndex * 2) + 1], value, textStyle, fontScale, selectionAnimation, fontPadding);
                chipImageIndex++;
                this.betButtons.push(betButton);
                this.add(betButton);
                if (index == 1)
                    betButton.Select();
            }
        });

        this.scene.game.events.on(Constants.EVENTS.BET_SELECTED, (index) => this.SelectChip(index, true));

        this.scene.game.events.on(Constants.EVENTS.CLIENT_CHIP_VALUE_CHANGE, (index) => this.SelectChip(index, true));//when someone else changes your chip index, like logic
        this.scene.game.events.on(Constants.EVENTS.STAKE_CHANGED, () => {
            this.betButtons.forEach((button, i) => {
                let trueSelectedIndex = i;
                if (!this.eraser)
                    trueSelectedIndex++;
                button.UpdateValue(Client.logic.ChipValues[trueSelectedIndex])
            })
            this.UpdatePosition(this.width, this.height);
        }, this);
    }

    public SelectChip(selectedIndex: number, setFromLogic: boolean = false, eraser: Eraser = null): void {
        this.betButtons.forEach((chip, index) => {
            let trueSelectedIndex = selectedIndex;
            if (eraser) {
                eraser.active = true;
                eraser.ClearAllSelect();
                this.scene.sound.play(Constants.SOUNDS.CHIP_SELECT, { volume: 0.45 * effectsVolume });
            } else {
                if (!this.eraser)
                    trueSelectedIndex--;

                if (index == trueSelectedIndex) {
                    if (chip.active && (chip instanceof Eraser) && Client.logic.BetSum > 0) {
                        if (chip.clearAllMode) {
                            Client.game.events.emit(Constants.EVENTS.CLEAR_ALL);
                            chip.Deselect();
                            chip.Select();
                        }
                        else {
                            chip.ClearAllSelect();
                            //we could play a different sound here ?
                            this.scene.sound.play(Constants.SOUNDS.CHIP_SELECT, { volume: 0.45 * effectsVolume });
                        }
                    }
                    else if (!chip.active) {
                        if (!setFromLogic)//prevents event emit loopback
                            Client.game.events.emit(Constants.EVENTS.BET_SELECTED, selectedIndex);

                        this.scene.sound.play(Constants.SOUNDS.CHIP_SELECT, { volume: 0.45 * effectsVolume });
                        chip.Select();
                    }
                } else {
                    chip.Deselect();
                }
            }
        });
        Client.remote.RemoteActionsHaveChanged();
    }

    public UpdatePosition(width: number, height: number): void {
        this.width = width;
        this.height = height;

        let chipSize;
        if (this.eraser)
            chipSize = Math.min(height, width / (((this.chipNum + 1) * this.chipOffset) + (1 - this.chipOffset)));//eraser adds one more space in between eraser<->chips
        else
            chipSize = Math.min(height, width / ((this.chipNum * this.chipOffset) + (1 - this.chipOffset)));

        let lastChipPosition = chipSize * (this.betButtons.length - 1);
        if (this.eraser)
            lastChipPosition += chipSize / this.chipNum;
        let totalOffset = width - lastChipPosition;

        this.betButtons.forEach((chip, index) => {
            chip.UpdateSize(chipSize, chipSize);
            chip.setPosition((chipSize / 2 + chipSize * index * this.chipOffset), height - (chipSize / 2));
            //if we have an eraser, we increase space between eraser and chips to prevent mobile users missclicking
            if (this.eraser && !(chip instanceof Eraser)) {
                chip.x += chipSize / 2 * this.chipOffset;
            }

            chip.x += totalOffset;
        });
    }

}

export class BetButton extends Phaser.GameObjects.Container {
    public active: boolean = false;

    protected activeFrame: string;
    protected inactiveFrame: string;
    protected tex: Phaser.GameObjects.Image;
    protected selectionAnimation: Phaser.GameObjects.Sprite;

    private value: Phaser.GameObjects.BitmapText;

    constructor(scene: Phaser.Scene, hodler: BetChips, indexID: number, spriteSheet: string, activeFrame: string, inactiveFrame: string, value: number, textStyle = null, private fontScale: number = 0.55, selectionAnimation: string = null, private fontPadding: number = 0.6) {
        super(scene);

        if (selectionAnimation) {
            this.selectionAnimation = new Phaser.GameObjects.Sprite(this.scene, 0, 0, "");
            this.selectionAnimation.setBlendMode(Phaser.BlendModes.ADD);
            this.selectionAnimation.play(selectionAnimation);
            this.selectionAnimation.addToUpdateList();
            this.selectionAnimation.setOrigin(0.5);
            this.selectionAnimation.setVisible(false);
            this.add(this.selectionAnimation);
        }

        this.activeFrame = activeFrame;
        this.inactiveFrame = inactiveFrame;

        this.tex = new Phaser.GameObjects.Image(scene, 0, 0, spriteSheet, inactiveFrame).setOrigin(0.5);
        this.tex.setInteractive().on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, (m, x, y, e) => {
            e.stopPropagation();
            hodler.SelectChip(indexID);
        }, this);
        this.add(this.tex);

        if (value > 0 && textStyle) {
            let val: any = value;
            if (value == Constants.VALUE_TO_CONSIDER_MAX_BET)//special value
                val = "MAX";
            this.value = new Phaser.GameObjects.BitmapText(scene, 0, 0, textStyle, val.toString(), 16).setOrigin(0.5).setTint(0x000000);
            this.add(this.value);
        }
    }

    public UpdateValue(newValue: number): void {
        if (!this.value)
            return;

        let val: any = newValue;
        if (newValue == Constants.VALUE_TO_CONSIDER_MAX_BET)//special value
            val = "MAX";
        this.value.text = val.toString();

        if (this.value.text.length < 2)
            autoScaleFont(this.value, this.width * 0.6, this.height * 0.6);
        else
            autoScaleFont(this.value, this.width, this.height);
    }

    public UpdateSize(width, height): void {
        this.width = width;
        this.height = height;

        this.tex.setDisplaySize(width, height);
        if (this.value) {
            if (this.value.text.length < 2)
                autoScaleFont(this.value, this.width * 0.6, this.height * 0.6);
            else
                autoScaleFont(this.value, this.width, this.height);
        }

        if (this.selectionAnimation) {
            this.selectionAnimation.setScale(this.tex.scale);
            this.selectionAnimation.setPosition(this.value.x, this.value.y);
        }
    }

    public Select(): void {
        this.active = true;
        this.tex.setFrame(this.activeFrame);
        if (this.selectionAnimation)
            this.selectionAnimation.visible = true;
    }

    public Deselect(): void {
        this.active = false;
        this.tex.setFrame(this.inactiveFrame);
        if (this.selectionAnimation)
            this.selectionAnimation.visible = false;
    }
}

export class Eraser extends BetButton {
    public clearAllMode: boolean = false;

    private clearAllFrame: string;

    constructor(
        scene: Phaser.Scene,
        hodler: BetChips,
        indexID: number,
        spriteSheet: string,
        activeFrame: string,
        inactiveFrame: string,
        clearAllFrame: string
    ) {
        super(
            scene,
            hodler,
            indexID,
            spriteSheet,
            activeFrame,
            inactiveFrame,
            -1,
            null,
            0.55
        );
        this.clearAllFrame = clearAllFrame;
    }

    public ClearAllSelect(): void {
        this.clearAllMode = true;
        this.tex.setFrame(this.clearAllFrame);
    }

    public override Deselect(): void {
        super.Deselect();
        this.clearAllMode = false;
    }
}